import { Deserializable } from "../../../common/deserializable";

/* class utilisé pour stocker les valeurs saisie dans l'écran de recherche afin de les afficher 
/** dans un deuxième temps dans le résultat de la recherche avancé */

export class RechercheOffresCommercialesFormNom implements Deserializable {
  portImport: string;
  portExport: string;
  typeTransport: string;
  compagnie: string;
  directTransbo: string;
  portArrivee: string;
  manutentionnaire: string;

  constructor(
    portImport,
    portExport,
    typeTransport,
    compagnie,
    directTransbo,
    portArrivee,
    manutentionnaire
  ) {
    this.portImport = portImport;
    this.portExport = portExport;
    this.typeTransport = typeTransport;
    this.compagnie = compagnie;
    this.directTransbo = directTransbo;
    this.portArrivee = portArrivee;
    this.manutentionnaire = manutentionnaire;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/offrecommerciale/model/form/rechercheOffreCommercialFormNom.ts